/**
 * pdfjs-dist 6 calls Map/WeakMap `getOrInsert` and `getOrInsertComputed` (the
 * TC39 upsert proposal) unconditionally. They are unavailable below roughly
 * Chrome 147, where loading a PDF throws
 * "this[#methodPromises].getOrInsertComputed is not a function".
 *
 * Must be imported before pdfjs, in both the main thread and the worker.
 */

type Upsertable = {
    has(key: any): boolean;
    get(key: any): any;
    set(key: any, value: any): any;
};

function install(proto: any) {
    if (typeof proto?.getOrInsert !== "function") {
        proto.getOrInsert = function (this: Upsertable, key: any, value: any) {
            if (this.has(key)) return this.get(key);
            this.set(key, value);
            return value;
        };
    }
    if (typeof proto?.getOrInsertComputed !== "function") {
        proto.getOrInsertComputed = function (this: Upsertable, key: any, callback: (key: any) => any) {
            if (this.has(key)) return this.get(key);
            const value = callback(key);
            this.set(key, value);
            return value;
        };
    }
}

install(Map.prototype);
install(WeakMap.prototype);

export {};
